import mediaQueries from 'styles/mediaQueries';
import mediaQueryBuilder from 'styles/helpers/mediaQueryBuilder';
import styled from '@emotion/styled';
import { Theme } from 'widget/styles/themes';

type Props = {
  'data-test'?: string;
  height: number;
};

const Rows = styled('div')<Props>(
  ({ height, theme }: Props & { theme: Theme }) => ({
    backgroundColor: theme.backgroundTertiary,
    height: `${height - 164}px`, // window height minus top section to get true height of Rows
    marginTop: '8.2rem',
    overflow: 'scroll',
    [mediaQueryBuilder(mediaQueries.max.height['399'])]: {
      height: `${height - 157}px`,
      marginTop: '7.5rem',
    },
    [mediaQueryBuilder(mediaQueries.max.width['199'])]: {
      height: `${height - 127}px`,
      marginTop: '4.9rem',
    },
  }),
);

export default Rows;
